// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4073":"b533a4a00c644777","4758":"3b6403538411211d"}[chunkId] + ".css";
};